<div class="map-ui
            absolute
            flex flex-col
            max-w-[700px]"
     [style.width.px]="containerWidthPx()">
  <div class="flex flex-row items-center">
    <mat-form-field (click)="$event.stopPropagation()"
                    appearance="fill"
                    class="pac-input">
      <mat-icon matPrefix [class.text-primary]="pacInput.value?.length"
                svgIcon="search"></mat-icon>
      <input matInput appGxInput
             placeholder="Places search"
             type="text"
             (keydown)="onAutocompleteChange()"
             #pacInput
      >
      @if (pacInput.value) {
        <button matSuffix mat-icon-button aria-label="Clear"
                (click)="clearAutocomplete()"
                [class.invisible]="!pacInput.value?.length">
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      }
    </mat-form-field>

    <!--      CV Mode     -->
    <button mat-stroked-button
            (click)="onToggleCvMode()"
            class="h-9 min-w-[98px] px-0"
            [ngClass]="{'text-neutral-30': !cvButtonActive(),
                        'text-neutral-10': cvButtonActive(),
                        'bg-blue-90': cvButtonActive()}">
      <mat-icon
          class="h-[24px] w-[24px] text-[24px] mr-0 mb-[3px]"
          svgIcon="where_to_vote_outlined">
      </mat-icon>
      <span class="text-[14px]">Validate</span>
    </button>

    <!--      toggle marker size     -->
    <button mat-icon-button
            (click)="onToggleMinimizeMarkers()"
            class="text-neutral-30 mx-2">
      <mat-icon
          class="h-[24px] w-[24px] text-[24px]"
          [svgIcon]="markersMinimized() ? 'maximize_pin' : 'minimize_pin'">
      </mat-icon>
    </button>
  </div>

</div>

